export default "__VITE_ASSET__ac6090bd__"